import {
  GET_LIST,
  GET_ONE,
  CREATE,
  UPDATE,
  DELETE,
  GET_MANY,
  GET_MANY_REFERENCE,
  GET_META,
  EXPORT
} from 'api/types';

export const CRUD_GET_LIST = 'CRUD_GET_LIST';
export const CRUD_GET_LIST_LOADING = 'CRUD_GET_LIST_LOADING';
export const CRUD_GET_LIST_FAILURE = 'CRUD_GET_LIST_FAILURE';
export const CRUD_GET_LIST_SUCCESS = 'CRUD_GET_LIST_SUCCESS';

export const crudGetList = (resource, apiPath, filter, cancelPrevious = true) => ({
  type: CRUD_GET_LIST,
  payload: { ...filter },
  meta: { resource, apiPath, fetch: GET_LIST, cancelPrevious },
});

export const CRUD_GET_ONE = 'CRUD_GET_ONE';
export const CRUD_GET_ONE_LOADING = 'CRUD_GET_ONE_LOADING';
export const CRUD_GET_ONE_FAILURE = 'CRUD_GET_ONE_FAILURE';
export const CRUD_GET_ONE_SUCCESS = 'CRUD_GET_ONE_SUCCESS';

export const crudGetOne = (resource, id, apiPath, basePath, cancelPrevious = true) => ({
  type: CRUD_GET_ONE,
  payload: { id, apiPath, basePath },
  meta: { resource, apiPath, fetch: GET_ONE, cancelPrevious },
});

export const CRUD_CREATE = 'CRUD_CREATE';
export const CRUD_CREATE_LOADING = 'CRUD_CREATE_LOADING';
export const CRUD_CREATE_FAILURE = 'CRUD_CREATE_FAILURE';
export const CRUD_CREATE_SUCCESS = 'CRUD_CREATE_SUCCESS';

export const crudCreate = (resource, data, apiPath, redirectPath, redirect = true, callback) => ({
  type: CRUD_CREATE,
  payload: { data, redirect, redirectPath },
  meta: { resource, apiPath, fetch: CREATE, cancelPrevious: false },
  callback: callback,
});

export const CRUD_UPDATE = 'CRUD_UPDATE';
export const CRUD_UPDATE_LOADING = 'CRUD_UPDATE_LOADING';
export const CRUD_UPDATE_FAILURE = 'CRUD_UPDATE_FAILURE';
export const CRUD_UPDATE_SUCCESS = 'CRUD_UPDATE_SUCCESS';

export const crudUpdate = (resource, id, data, previousData,
                           apiPath, redirectPath = '', notification = '', callback) => ({
  type: CRUD_UPDATE,
  payload: { id, data, previousData, apiPath, redirectPath, redirect: !!redirectPath },
  meta: { resource, apiPath, fetch: UPDATE, cancelPrevious: false, notification },
  callback: callback,
});

export const CRUD_DELETE = 'CRUD_DELETE';
export const CRUD_DELETE_LOADING = 'CRUD_DELETE_LOADING';
export const CRUD_DELETE_FAILURE = 'CRUD_DELETE_FAILURE';
export const CRUD_DELETE_SUCCESS = 'CRUD_DELETE_SUCCESS';

export const crudDelete = (resource, id, basePath, redirect = true) => ({
  type: CRUD_DELETE,
  payload: { id, basePath, redirect },
  meta: { resource, fetch: DELETE, cancelPrevious: false },
});


export const CREATE_AND_UPDATE = 'CREATE_AND_UPDATE';
export const CREATE_AND_UPDATE_LOADING = 'CREATE_AND_UPDATE_LOADING';
export const CREATE_AND_UPDATE_FAILURE = 'CREATE_AND_UPDATE_FAILURE';
export const CREATE_AND_UPDATE_SUCCESS = 'CREATE_AND_UPDATE_SUCCESS';

export const createAndUpdate = (resource, data, apiPath, redirectPath, redirect = true) => ({
  type: CREATE_AND_UPDATE,
  payload: { data, redirect, redirectPath },
  meta: { resource, apiPath, fetch: CREATE, cancelPrevious: false },
});


export const CRUD_GET_MANY = 'CRUD_GET_MANY';
export const CRUD_GET_MANY_LOADING = 'CRUD_GET_MANY_LOADING';
export const CRUD_GET_MANY_FAILURE = 'CRUD_GET_MANY_FAILURE';
export const CRUD_GET_MANY_SUCCESS = 'CRUD_GET_MANY_SUCCESS';

// Reference related actions

export const crudGetMany = (resource, ids) => ({
  type: CRUD_GET_MANY,
  payload: { ids },
  meta: { resource, fetch: GET_MANY, cancelPrevious: false },
});

export const CRUD_GET_MATCHING = 'CRUD_GET_MATCHING';
export const CRUD_GET_MATCHING_LOADING = 'CRUD_GET_MATCHING_LOADING';
export const CRUD_GET_MATCHING_FAILURE = 'CRUD_GET_MATCHING_FAILURE';
export const CRUD_GET_MATCHING_SUCCESS = 'CRUD_GET_MATCHING_SUCCESS';

export const crudGetMatching = (reference, relatedTo, pagination, sort, filter) => ({
  type: CRUD_GET_MATCHING,
  payload: { pagination, sort, filter },
  meta: { resource: reference, relatedTo, fetch: GET_LIST, cancelPrevious: false },
});

export const CRUD_GET_MANY_REFERENCE = 'CRUD_GET_MANY_REFERENCE';
export const CRUD_GET_MANY_REFERENCE_LOADING = 'CRUD_GET_MANY_REFERENCE_LOADING';
export const CRUD_GET_MANY_REFERENCE_FAILURE = 'CRUD_GET_MANY_REFERENCE_FAILURE';
export const CRUD_GET_MANY_REFERENCE_SUCCESS = 'CRUD_GET_MANY_REFERENCE_SUCCESS';

export const crudGetManyReference = (reference, target, id, relatedTo, pagination, sort, filter) => ({
  type: CRUD_GET_MANY_REFERENCE,
  payload: { target, id, pagination, sort, filter },
  meta: { resource: reference, relatedTo, fetch: GET_MANY_REFERENCE, cancelPrevious: false },
});


export const CRUD_GET_META = 'CRUD_GET_META';
export const CRUD_GET_META_LOADING = 'CRUD_GET_META_LOADING';
export const CRUD_GET_META_FAILURE = 'CRUD_GET_META_FAILURE';
export const CRUD_GET_META_SUCCESS = 'CRUD_GET_META_SUCCESS';

export const crudGetMeta = (resource, apiPath, filters = {}, cancelPrevious = true) => ({
  type: CRUD_GET_META,
  payload: { ...filters },
  meta: { resource, apiPath, fetch: GET_META, cancelPrevious },
});

export const CLEAR_CURD_RESOURCE_DATA = 'CLEAR_CURD_RESOURCE_DATA';
export const clearCrudResourceData = (resourceName) => ({
  type: CLEAR_CURD_RESOURCE_DATA,
  meta: {
    resource: resourceName,
    isCustomRequest: true,
    type: CLEAR_CURD_RESOURCE_DATA,
  }
});

export const CRUD_EXPORT = 'CRUD_EXPORT';
export const CRUD_EXPORT_LOADING = 'CRUD_EXPORT_LOADING';
export const CRUD_EXPORT_FAILURE = 'CRUD_EXPORT_FAILURE';
export const CRUD_EXPORT_SUCCESS = 'CRUD_EXPORT_SUCCESS';

export const crudExportToEmail = (data, apiPath, cancelPrevious = true) => ({
  type: CRUD_EXPORT,
  payload: { data },
  meta: {  apiPath, fetch: EXPORT, cancelPrevious },
});


export const CHANGE_CURD_RESOURCE_DATA = 'CHANGE_CURD_RESOURCE_DATA';
export const changeCrudResourceData = (resourceName, data) =>{
  return {
    type: CHANGE_CURD_RESOURCE_DATA,
    payload: { data },
    meta: {
      resource: resourceName,
      isCustomRequest: true,
      type: CHANGE_CURD_RESOURCE_DATA,
    }
  }

}


// WEBPACK FOOTER //
// ./src/actions/dataActions.js